<template>
  <el-card class="user-content-panel">
    <div slot="header" class="clearfix">
      <span class="panel-header">账号信息</span>
    </div>
    <div class="user-avatar">
      <img src="../../assets/images/user.png" >
    </div>
    <div class="user-name">
      Susie.Su
    </div>

    <el-form :model="userInfo" label-position="right" label-width="100px" class="user-form">
      <el-row>
        <el-col :span="12">
          <el-form-item label="用户账号">
            <el-input v-model="userInfo.loginAccount" />
          </el-form-item>
          <el-form-item label="工作岗位">
            <el-input v-model="userInfo.workTitle" />
          </el-form-item>
          <el-form-item label="所属事业部">
            <el-input v-model="userInfo.workBu" />
          </el-form-item>
          <el-form-item label="所属区域">
            <el-input v-model="userInfo.workRegion" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="联系电话">
            <el-input v-model="userInfo.mobile" />
          </el-form-item>
          <el-form-item label="所在地区">
            <el-input v-model="userInfo.province" />
          </el-form-item>
          <el-form-item label="详细地址">
            <el-input v-model="userInfo.detailAddress" />
          </el-form-item>
          <el-form-item label="邮政编码">
            <el-input v-model="userInfo.zipCode" />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <div class="button-line">
      <el-button class="btn-save" @click="saveUserInfo">保存设置</el-button>
      <el-button class="btn-back" @click="back">取消</el-button>
    </div>
  </el-card>
</template>

<script>
export default {
  name: 'account-info',

  data () {
    return {
      userInfo: {
        loginAccount: 'susie.su@futureplat.com',
        workTitle: 'TR',
        workBu: '东南区',
        workRegion: '福建福州',
        mobile: '15800001234',
        province: '中国 上海市 浦东',
        detailAddress: '上海市浦东新区亮秀路112号',
        zipCode: '200220'
      }
    }
  },
  methods: {
    saveUserInfo () {},
    back () {
      this.$router.go(-1)
    }
  }
}
</script>

<style lang="scss" scoped>
.user-content-panel {
  .user-avatar {
    width: 80px;
    height: 80px;
    overflow: hidden;
    margin: 10px auto;
    border: 2px solid $base-grey;
    border-radius: 50%;
    img {
      max-width: 100%;
      max-height: 100%;
    }
  }
  .user-opt-line {
    text-align: center;
  }
  .user-name {
    text-align: center;
    font-size: 24px;
    font-weight: 700;
    padding: 0 0 16px 0;
  }

  .user-form {
    width: 90%;
    margin: 0 auto;
  }

  .button-line {
    text-align: center;

    .btn-save {
      border-color: $base-blue;
      color: $base-blue;
    }

    .btn-back {
      border: 0;
      background-color: $base-grey3;
      color: $base-black;
    }
  }
}
</style>
